/* @flow */
import Subscribers from 'collections/Subscribers';
import ToastActions from 'actions/ToastActions';

const SubscriberActions = {
  export(groupIds: Backbone$Id[]) {
    Subscribers.export(groupIds)
      .then(() => {
        ToastActions.showSuccessToast('We’ve emailed you a list of your participants.');
      })
      .catch(error => {
        ToastActions.showAPIError(error);
        throw error;
      });
  },
};
export default SubscriberActions;
